import { Flex, Image, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { MainBannerV2Props } from "../MainBannerV2";

export const MainBannerColumnItems: FC<MainBannerV2Props> = ({
  data,
  getImageUrl,
}) => {
  return (
    <Flex
      flexWrap="wrap"
      justify="center"
      gap={8}
      md={{ gap: 12, m: { mb: 76 } }}
      m={{ mb: 36 }}
      maxWidth="90%"
    >
      {data?.items?.map((item) => (
        <Flex
          key={item?.id}
          align="center"
          justify="center"
          minWidth={308}
          maxWidth={400}
          md={{ width: 336 }}
          d={{ minHeight: 136 }}
          bg="surface-primary-dark"
          className="backdrop-blur-xl  self-stretch transform skew-x-[-16deg]"
        >
          <Flex
            p={{ px: 25, pb: 8, pt: 10 }}
            md={{ p: { py: 20 } }}
            className="transform items-center text-center skew-x-[16deg] "
            flexDirection="column"
          >
            {item.main_banner_items_id?.icon && (
              <Image
                value={getImageUrl(item?.main_banner_items_id?.icon?.id ?? "", {
                  height: 32,
                  width: 32,
                  format: "webp",
                })}
                maxWidth={24}
                md={{ maxWidth: 32 }}
                m={{ mb: 8 }}
              />
            )}
            <Typography
              size="medium"
              md={{
                fontSize: "button.desktop.medium",
                lineHeight: "button.desktop.medium",
              }}
              className=" md:whitespace-pre-line"
            >
              {item?.main_banner_items_id?.text}
            </Typography>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
